import { userForm } from "../main";
import { submitUser } from "../forms/user";
import { FORM_INPUTS } from "./formInputs";

const fillOfferTariff = () => {
    const OFFER_TARIFF = document.getElementById('offerTariff');
    if (!OFFER_TARIFF) return

    const offerTariffElements = document.querySelectorAll('[data-tariff="offer"]');

    offerTariffElements?.forEach(e => e.innerHTML = OFFER_TARIFF.value)
}

const fillTrxId = () => {
    const TRX_ID_ELEMENT = document.getElementById('trxId');
    if (!TRX_ID_ELEMENT) return

    const trxElements = document.querySelectorAll('[data-trx="id"]');

    trxElements?.forEach(e => e.innerHTML = TRX_ID_ELEMENT.value)
}

const fillProductName = () => {
    const PRODUCT_NAME_ELEMENT = document.getElementById('rewardName');
    if (!PRODUCT_NAME_ELEMENT) return
    const rewardsNameElement = document.querySelectorAll('.page-reward-name');

    rewardsNameElement?.forEach(e => e.innerHTML = PRODUCT_NAME_ELEMENT.value)
}

const fillDrawDate = () => {
    const DRAW_DATE_ELEMENT = document.getElementById('selected-winner-date');
    if (!DRAW_DATE_ELEMENT) return;

    let date = new Date();
    date.setMonth(date.getMonth() + 3, 0);

    DRAW_DATE_ELEMENT.innerHTML = date.toLocaleDateString();
}

export const fillPlaceholders = () => {
    fillTrxId();
    fillProductName();
    fillOfferTariff();
    fillDrawDate();
}

export const checkIfAllUserDataIsFilledAndGoToPaymentStep = () => {
    const AUTO_CONTINUE_VALUE = document.getElementById('autoContinueIndicator')?.value;

    if (!userForm || AUTO_CONTINUE_VALUE !== 'enabled') return

    if (FORM_INPUTS.phoneNumber.element && document.getElementById('phoneNumberCustom')) {
        document.getElementById('phoneNumberCustom').value = FORM_INPUTS.phoneNumber.element.value;
    }

    const inputFields = userForm.querySelectorAll('input[required]');

    const isEveryInputFilled = Array.from(inputFields).every(e => e.value);

    if (isEveryInputFilled) {
        submitUser()
    }
}

window.fillPlaceholders = fillPlaceholders;
